import { Clear } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AdornmentLens } from "@ryde/controls";

import { MobileSettingsSearchWrapperStyled } from "./mobile.settings.styled";
import { useMobileSettingsSearch } from "./use-mobile-settings-search";

export const MobileSettingsSearch: FC = () => {
  const { t } = useTranslation();
  const { searchText, inputRef, onSearchChange, onClearSearch } =
    useMobileSettingsSearch();

  return (
    <MobileSettingsSearchWrapperStyled>
      <TextField
        fullWidth
        label={t("general.SEARCH")}
        value={searchText}
        data-e2e="search-settings"
        autoComplete="off"
        size="small"
        inputRef={inputRef}
        onChange={onSearchChange}
        slotProps={{
          input: {
            startAdornment: <AdornmentLens />,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Clear search field" // TODO: add translation solution/key ? if it is an actual label here and general maybe broader solution..
                  onClick={onClearSearch}
                  edge="end"
                >
                  <Clear />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </MobileSettingsSearchWrapperStyled>
  );
};
